module.exports = __webpack_public_path__ + "img/advantage4Orange.e5ff7362.png";